export default __webpack_public_path__ + "static/media/omnione_logo_color.62f69a24.svg";